{
  "es": {
    "todo_list": {
      "actions": {
        "add": "Crear lista de tareas",
        "cancel": "Deshacer",
        "delete_todo_list": "Eliminar lista",
        "edit": "Editar lista de tareas",
        "new": "Lista de tareas",
        "save": "Guardar",
        "title": "Título de la lista"
      },
      "attributes": {
        "name": "Título"
      },
      "labels": {
        "assignToLevel": "Asignar a nivel",
        "createdAt": "Creado el",
        "filter_employee": "Responsable",
        "newTodoList": "Nueva lista de tareas",
        "sort": {
          "created_at_asc": "Más antiguas primero",
          "created_at_desc": "Más recientes primero",
          "name_lower_asc": "Título A -> Z",
          "name_lower_desc": "Título Z -> A"
        }
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Mantén una vista general de tus tareas y las de tu equipo.",
            "title": "Abrir una nueva lista de tareas"
          }
        }
      },
      "toasts": {
        "create": "Lista de tareas creada correctamente",
        "delete": "Lista de tareas eliminada correctamente",
        "update": "Lista de tareas actualizada correctamente"
      },
      "validation": {
        "needTitle": "El título es obligatorio"
      }
    }
  }
}
